"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductType = exports.MediaType = void 0;
var MediaType;
(function (MediaType) {
  MediaType["image"] = "IMAGE";
  MediaType["video"] = "VIDEO";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var ProductType;
(function (ProductType) {
  ProductType["material"] = "MATERIAL";
  ProductType["project"] = "PROJECT";
  ProductType["media"] = "MEDIA";
  ProductType["masterclass"] = "MASTERCLASS";
  ProductType["subscription"] = "SUBSCRIPTION";
})(ProductType = exports.ProductType || (exports.ProductType = {}));